import React from "react";
import styled from "styled-components";

import HeroCard from "./HeroCard";
import DiagnosisCard from "./DiagnosisCard";
import TemaPriorityCard from "./TemaPriorityCard";
import StudyPlanCard from "./StudyPlanCard";
import CareerProjectionCard from "./CareerProjectionCard";
import DailyBriefingCard from "./DailyBriefingCard";
import NoticiasCard from "./NoticiasCard";
import QuickActionsCard from "./QuickActionsCard";

const Container = styled.div`
    display:flex;
    flex-direction:column;
    gap:24px;

    padding:24px clamp(20px,4vw,40px) 40px;

    max-width:1600px;
    margin:0 auto;

    box-sizing:border-box;
`;

const Grid2 = styled.div`
    display:grid;
    grid-template-columns:repeat(auto-fit,minmax(320px,1fr));
    gap:20px;
`;

export default function Dashboard({

    tutor,

    usuario,

    progreso,

    noticia,

    carreras,

    carreraSeleccionada,

    onCambiarCarrera,

    onEntrenar,

    onPerfil,

    onCerrarSesion,

    perfilActivo,

onCambiarPerfil,

examenes,

examenSeleccionado,

onCambiarExamen,

onGrupos,

onMisMetas

}) {

    return(

        <Container>

<HeroCard

nombre={
    usuario?.nick ||
    usuario?.nombre ||
    "Estudiante"
}

nivel={tutor.nivel}

carrera={
    tutor.carreraObjetivo.nombre
}

universidad={
    tutor.carreraObjetivo.universidad
}

ciudad={
    tutor.carreraObjetivo.ciudad
}

carreras={carreras}

carreraSeleccionada={
    carreraSeleccionada
}

onCambiarCarrera={
    onCambiarCarrera
}

puntajeEstimado={
    tutor.puntajeEstimado
}

puntajeObjetivo={
    tutor.puntajeObjetivo
}

probabilidad={
    tutor.probabilidad
}

xp={
    progreso?.xp || 0
}

racha={
    progreso?.streak_actual || 0
}

examenes={examenes}

examenSeleccionado={examenSeleccionado}

onCambiarExamen={onCambiarExamen}

/>

<DailyBriefingCard

tutor={tutor}

/>

<div style={{height:25}}/>

<Grid2>

<DiagnosisCard

diagnostico={tutor.diagnostico}

/>

<TemaPriorityCard

temas={tutor.temasPrioritarios}

/>

</Grid2>

<div style={{height:25}}/>

<Grid2>

<StudyPlanCard

plan={tutor.planHoy}

/>

<CareerProjectionCard

carreras={tutor.potencialCarreras}

/>

</Grid2>

<div style={{height:25}}/>

<NoticiasCard

noticia={noticia}

/>

<div style={{height:25}}/>

<QuickActionsCard

onEntrenar={onEntrenar}

onPerfil={onPerfil}

onCerrarSesion={onCerrarSesion}

perfilActivo={perfilActivo}

    onCambiarPerfil={onCambiarPerfil}

    onGrupos={onGrupos}

    onMisMetas={onMisMetas}
    
/>

</Container>

);

}